module.exports = __webpack_public_path__ + "io.svg?9757dbd40227e830f63fda8453528949";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/io.svg
// module id = 96
// module chunks = 0